import { boolean, object, ObjectSchema, string } from 'yup';

import { RemitRemark } from '@/types/billing';
import { transformEmptyStringToNull } from '@/utils/transformEmptyStringToNull';

export const RemitRemarkSchema: ObjectSchema<
  Omit<RemitRemark, 'remit_service_line' | 'created_at' | 'updated_at' | 'id'>
> = object().shape({
  qualifier: string().trim().max(100).required().transform(transformEmptyStringToNull),
  code: string().trim().max(100).required().transform(transformEmptyStringToNull),

  _delete: boolean().optional()
});
